import type * as lazyIndex from './lazyIndex';
import { LazyModule, LazyAction } from 'owa-bundling';

const lazyModule: LazyModule<typeof lazyIndex> = new LazyModule(
    () => import(/* webpackChunkName: "ProactiveDraftStore"*/ './lazyIndex'),
    { name: 'ProactiveDraftStore' }
);

export const LazyPreloadProactiveDraftsForRowKey: LazyAction<
    typeof lazyIndex.preloadProactiveDraftsForRowKey,
    typeof lazyModule
> = new LazyAction(lazyModule, m => m.preloadProactiveDraftsForRowKey);

export const LazyGenerateProactiveDrafts: LazyAction<
    typeof lazyIndex.generateProactiveDrafts,
    typeof lazyModule
> = new LazyAction(lazyModule, m => m.generateProactiveDrafts);

export type { CustomNotificationMessages } from './services/generateProactiveDrafts';

// Re-export locstrings for communication styles notifications
export {
    communicationStylesInProgressTitle,
    communicationStylesInProgressDescription,
    communicationStylesCompleteTitle,
    communicationStylesCompleteDescription,
    communicationStylesFailedTitle,
    communicationStylesFailedDescription,
} from './services/generateProactiveDrafts.locstring.json';

export { ProactiveDraftCardState } from './store/schema/ProactiveDraftCardState';
export { ProactiveDraftsState } from './store/schema/ProactiveDraftsState';

export { getItemProactiveDraftsTelemetrySession } from './selectors/getItemProactiveDraftsTelemetrySession';
export { getCurrentProactiveDraftsTelemetrySession } from './selectors/getCurrentProactiveDraftsTelemetrySession';
export { default as setItemProactiveDraftsTelemetrySessionAndUpdateCurrentMutator } from './actions/setItemProactiveDraftsTelemetrySessionAndUpdateCurrentMutator';
export { default as setCurrentProactiveDraftsTelemetrySessionMutator } from './actions/setCurrentProactiveDraftsTelemetrySessionMutator';
export { getOrCreateProactiveDraftsViewState } from './selectors/getOrCreateProactiveDraftsViewState';
export { getProactiveDraftAddedOnEditor } from './selectors/getProactiveDraftAddedOnEditor';
export { getIsProactiveDraftsBarExpanded } from './selectors/getIsProactiveDraftsBarExpanded';
export { getProactiveDraftsBarVisibilityStatus } from './selectors/getProactiveDraftsBarVisibilityStatus';
export { default as setProactiveDraftsBarExpandedMutator } from './actions/setProactiveDraftsBarExpandedMutator';
export { default as setProactiveDraftsBarVisibleMutator } from './actions/setProactiveDraftsBarVisibleMutator';
export { default as isProactiveDraft } from './utils/isProactiveDraft';
